export default __webpack_public_path__ + "static/media/580.da163612.jpg";